// extracted by mini-css-extract-plugin
export default {"toggle":"ThemeToggle_toggle__uiNiN"};